"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMedicalExpenseData = exports.medicalExpenseFormRules = exports.medicalExpenseSchema = void 0;
const converters_1 = require("../../converters");
const expense_1 = require("./expense");
exports.medicalExpenseSchema = {
    fields: {
        ...expense_1.expenseSchema.fields,
    },
    messages: {
        ...expense_1.expenseSchema.messages,
        institution_name: {
            maxLength: 'Doctor/Pharmacy Name must be 50 characters or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.medicalExpenseFormRules = (0, converters_1.toReactHookForm)(exports.medicalExpenseSchema, expense_1.expenseFieldMapping);
exports.validateMedicalExpenseData = (0, converters_1.createValidator)(exports.medicalExpenseSchema);
